import React, { Component } from "react";
import { Col, Form, Row, Table, Typography } from "antd";
import PropTypes from "prop-types";
import { withApollo } from "react-apollo";
import { changeFormatFulldate } from "../../../../../utils/formatdate";

class WelfareListPaymentVictimSecDisasterHouse extends Component {
  state = {
    columns: [
      {
        title: "วันที่ดำเนินรายการ",
        dataIndex: "actionDate",
        align: "center",
        width: 200,
        render: (item, record, index) =>
          item ? changeFormatFulldate(item) : "-",
      },
      {
        title: "ผู้ดำเนินรายการ",
        dataIndex: "createdByFullName",
        align: "center",
        render: (item, record, index) => item || "-",
      },
      {
        title: "สถานะ",
        dataIndex: "statusName",
        align: "center",
        width: 130,
        render: (item, record, index) => item || "-",
      },
      {
        title: "ดำเนินการ",
        dataIndex: "statusActionName",
        align: "center",
        width: 130,
        render: (item, record, index) => item || "-",
      },
      {
        title: "หมายเหตุ",
        dataIndex: "remark",
        align: "center",
        ellipsis: true,
        render: (item, record, index) => item || "-",
      },
    ],
  };

  render() {
    const { rawData } = this.props;
    const { columns } = this.state;

    return (
      <Row gutter={16} type="flex" justify="start" align="top" className="py-2">
        <Col md={24} className="mb-3">
          <Typography.Text className="color-red" style={{ fontSize: "18px" }}>
            ประวัติการดำเนินการ
          </Typography.Text>
        </Col>

        <Col md={24} className="mb-2">
          <Form.Item className="mb-0" />
          <Table
            locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
            columns={columns}
            dataSource={rawData?.welfareHistory || []}
            rowKey="id"
          />
        </Col>
      </Row>
    );
  }
}

WelfareListPaymentVictimSecDisasterHouse.defaultProps = {
  autoFocus: false,
};

WelfareListPaymentVictimSecDisasterHouse.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListPaymentVictimSecDisasterHouse = Form.create()(
  WelfareListPaymentVictimSecDisasterHouse
);

export default withApollo(WrappedWelfareListPaymentVictimSecDisasterHouse);
